import React, { Component } from 'react';
import './contactus.scss'
import { Container } from 'react-bootstrap';
// Components

class ContactUs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            message: '',
            mailSent: false,
            error: null
        }
    }


    handleFormSubmit( event ) {
        event.preventDefault();
        console.log(this.state);
    }

    render() {
        return (
            <Container fluid={false}>
                <section className="contact-section">
                <h1>
                    Contact us for a free estimate
                </h1>
                <br/>
                <h2>
                    Call us: <a href="tel:4088387430">408-838-7430</a>
                </h2>
                <h2>
                    Email us: <a href="mailto:abctrees@yahoo.com">abctrees@yahoo.com</a>
                </h2>
                <br/>
                <h2>
                    10045 Monterey Rd Gilroy, CA 95020
                </h2>
                </section>
            </Container>
        );
  }
}

export default ContactUs;
